import styled, { css } from 'styled-components';
import { generateClassNames, applyDisplayNames } from '../../utils/functions';
import { Color as PColor } from '../../utils/types/palette';
var baseClassName = 'Backdrop';
var Backdrop = /*#__PURE__*/styled.div.attrs({
  className: generateClassNames(baseClassName, 'root')
}).withConfig({
  componentId: "sc-txa5a-0"
})(function (_ref) {
  var palette = _ref.theme.palette;
  return css(["position:fixed;display:flex;align-items:center;justify-content:center;inset:0px;background-color:", ";transition:opacity 251ms cubic-bezier(0.4,0,0.2,1) 0ms;opacity:1;z-index:-1;"], palette[PColor.Extra_0_3_Overlay]);
});
var Styled = applyDisplayNames({
  Backdrop: Backdrop
});
export default Styled;